import React from 'react';
import styles from './style.module.scss';

/**
 * The pure css circular loader indicator component
 **/
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var CSSProgressLoader = function CSSProgressLoader() {
  return /*#__PURE__*/_jsxs("div", {
    className: styles.ldsRing,
    style: {
      width: '43px',
      height: '43px',
      margin: '0 auto',
      position: 'relative',
      display: 'none'
    },
    children: [/*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx("div", {})]
  });
};
var PageLoadingSpinner = function PageLoadingSpinner(_ref) {
  var fullHeight = _ref.fullHeight,
    loadingMessage = _ref.loadingMessage;
  return /*#__PURE__*/_jsxs("div", {
    style: {
      height: fullHeight ? '100vh' : 'auto',
      display: 'flex',
      textAlign: 'center',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column'
    },
    children: [loadingMessage && /*#__PURE__*/_jsx("div", {
      style: {
        marginBottom: '25px'
      },
      children: loadingMessage
    }), /*#__PURE__*/_jsx(CSSProgressLoader, {})]
  });
};
export default /*#__PURE__*/React.memo(PageLoadingSpinner);